import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './twoColCta.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";

let customClass = "inline-block align-middle";

const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};


function TwoColCta(props) {

    const featuredimg = maybeImage(props.featuredimage);

    let sectionStyle = ((props.inverselayout) ? styles.sectionInverse+' ' : ' ') + styles.sectionTwoColCta;
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    return (
        <div className={sectionStyle} style={{ backgroundColor: `${bgColor}`}}>

            <div className={styles.sectionContainer}>

                <div className={styles.sectionFirstCol}>
                    <div className={styles.imageWrapper}>{featuredimg}</div>
                    <div className={styles.sectionContent}>
                        <h3>{props.heading}</h3>
                        <PortableText blocks={props.content} />
                        <a href={props.ctalink} className={styles.sectionCta}>
                            <span className={customClass}>{props.ctalabel}</span>
                            <img className={customClass} src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                        </a>
                    </div>
                </div>

                <div className={styles.sectionSecondCol}>
                    <div className={styles.imageWrapper}>{featuredimg}</div>
                    <div className={styles.sectionContent}>
                        <h3>{props.heading}</h3>
                        <PortableText blocks={props.content} />
                        <a href={props.ctalink} className={styles.sectionCta}>
                            <span className={customClass}>{props.ctalabel}</span>
                            <img className={customClass} src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                        </a>
                    </div>
                </div>

            </div>

        </div>
    );
}
  
export default TwoColCta;